import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { useApi } from 'app/api/APIProvider';
import { Title, TitleSize } from 'shared/ui/Title/Title';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { servicesActions } from 'features/Services';
import { formatNumber } from 'shared/lib/utils/utils';
import cls from './PolicyRegister.module.scss';

type FormData = {
    initialSum: string;
    yearSum: string;
    serverError: string;
    // yearFee: string;
};

interface IForm {
    text: string,
    initialSum?: boolean,
    yearSum?: boolean,
    fieldText?: {
        initialSumText?: string,
        yearSumText?: string,
        additionText?: string,
    },
    description?: string,
    showDescription?: boolean,
    buttonText: string,
    productKey: string,
};

interface PolicyThirdProps {
    form: IForm,
    callback?: () => void,
};

export const PolicyRegister = ({ form, callback }: PolicyThirdProps) => {
    const api = useApi();
    const dispatch = useDispatch();
    const queryParams = new URLSearchParams(window.location.search);
    const wallet = Number(queryParams.get('wallet'));
    const purchaseSum = Number(queryParams.get('sum'));
    const { initialSumText, yearSumText, additionText } = form.fieldText;

    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        setError,
        clearErrors,
    } = useForm<FormData>();

    const onSubmit: SubmitHandler<FormData> = async (data) => {
        try {
            if(form.productKey === 'credit10' && sessionStorage.getItem('credit')) return;
            await api.BuySpecialProduct({...data, productKey: form.productKey});
            dispatch(servicesActions.changeStatusInfo({ key: form.productKey, status: true }));
            callback();
            if (form.productKey === 'credit10') {
                sessionStorage.setItem('credit', '1');
            }
        } catch (error) {
            setError('serverError', {
                type: 'server',
                message: error.message,
            });
        }
    };

    return (
        <div id="form">
            <Text className={cls.title} color="#353850" size={TextSize.text_36}>Оформление</Text>
            <form className={cls.form}  onSubmit={handleSubmit(onSubmit)}>
                {
                    additionText && (
                        <Title className={`${cls.title} ${cls.noMb}`} color="#000" size={TitleSize.title_20_400}>
                            {additionText}
                        </Title>
                    )
                }
                {
                    form.initialSum && (
                        <div className={cls.cell}>
                            <Title className={cls.title} color="#000" size={TitleSize.title_20_400}>
                                {initialSumText}
                            </Title>
                            {
                                (wallet - purchaseSum) < 0 && <Text className={cls.title} color="#353850" size={TextSize.text_14}>
                                    {`Для покупки у вас не хватает ${formatNumber(-1 * (wallet - purchaseSum))} ₽`}
                                </Text>
                            }
                            <input className={cls.field} type="number" min={0} {...register('initialSum', { required: 'Заполните поле' })} placeholder="Введите сумму" />
                            {/* {errors.initialSum && <p className={cls.error}>{errors.initialSum.message}</p>} */}
                        </div>
                    )
                }
                {
                    form.yearSum && (
                        <div className={cls.cell}>
                            <Title className={cls.title} color="#000" size={TitleSize.title_20_400}>
                                {yearSumText}
                            </Title>
                            <input className={cls.field} type="number" min={0} {...register('yearSum', { required: 'Заполните поле' })} placeholder="Введите сумму" />
                            {/* {errors.yearSum && <p className={cls.error}>{errors.yearSum.message}</p>} */}
                        </div>
                    )
                }
                {
                    form.showDescription && (
                        <Text className={cls.title} color="#353850" size={TextSize.text_20}>
                            {form.text}
                        </Text>
                    )
                }
                {errors.serverError && <Text color="#FF4500" size={TextSize.text_18}>{errors.serverError.message}</Text>}
                <Button className={cls.button3} type="submit" theme={ButtonTheme.AUTH} onClick={() => clearErrors('serverError')}>
                    Оформить
                </Button>
            </form>
        </div>
    );
};

